import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";
import { postTags, updateTags } from "./tags";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  blogs: [],
  singleBlog: {},
  fetchLoading: false,
};

const slice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // FETCH  LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
    },

    // TODO: success post blog

    postBlogSuccess(state, action) {
      state.isLoading = false;
      // state.blogs.data = [action.payload, ...state.blogs.data];
      // state.blogs.meta.total += 1;
    },
    // TODO: successFetch blog

    getBlogSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.blogs = action.payload;
    },

    // TODO: single blog fetch success

    getSingleBlogSucess(state, action) {
      state.isLoading = false;
      state.singleBlog = action.payload;
    },

    // Update blog
    updateBlogSuccess(state, action) {
      state.isLoading = false;
      // state.blogs.data = state.blogs.data.map((blog) => {
      //   if (blog.slug === action.payload.slug) {
      //     return action.payload;
      //   } else {
      //     return blog;
      //   }
      // });
    },

    // delete blog
    deleteBlogSuccess(state, action) {
      state.isLoading = false;
      // state.blogs.data = state.blogs.data.filter(
      //   (blog) => blog.id !== action.payload
      // );
      // state.blogs.meta.total -= 1;
    },
  },
});

export default slice.reducer;

export function getBlogs({ categoryId, limit = 5, page = 1, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`items`, {
        params: {
          limit,
          page: page + 1,
          category_slug: categoryId,
          season_id,
        },
      });

      dispatch(
        slice.actions.getBlogSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateBlog({ slug, data, tagData, enqueueSnackbar, tag_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items/${slug}`, data);

      if (
        tagData?.team ||
        tagData?.player ||
        tagData?.game ||
        tagData?.category
      ) {
        if (tag_id) {
          dispatch(
            updateTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
              tag_id,
            })
          );
        } else {
          dispatch(
            postTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
            })
          );
        }
      }

      dispatch(slice.actions.updateBlogSuccess(response.data.data));
      enqueueSnackbar("News is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postBlogs({ data, enqueueSnackbar, tagData, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items`, data);

      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );
      dispatch(slice.actions.stopLoading());
      enqueueSnackbar("News is created successfully");
      navigate(PATH_DASHBOARD.news.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBlog(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`items/${id}`);

      dispatch(slice.actions.getSingleBlogSucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteBlog({
  id,
  enqueueSnackbar,
  pagination,
  categoryId,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`items/${id}`);
      dispatch(slice.actions.deleteBlogSuccess(id));
      dispatch(
        getBlogs({
          categoryId,
          page: pagination.page,
          limit: pagination.limit,
          season_id,
        })
      );
      enqueueSnackbar("Content is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
